import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Brain, TrendingUp, MessageSquare, BarChart, CheckCircle, Star } from 'lucide-react';

const IAPage = () => {
  const features = [
    'Chatbots inteligentes para atendimento',
    'Análise preditiva de vendas',
    'Automação de marketing personalizada',
    'Insights de dados em tempo real',
    'Recomendações inteligentes',
    'Integração com sistemas existentes'
  ];

  const benefits = [
    { icon: Brain, title: 'Inteligência Artificial', desc: 'Algoritmos avançados de machine learning' },
    { icon: MessageSquare, title: 'Atendimento 24/7', desc: 'Chatbots que nunca dormem' },
    { icon: BarChart, title: 'Analytics Avançado', desc: 'Previsões precisas e insights valiosos' },
    { icon: TrendingUp, title: 'Otimização Contínua', desc: 'Melhoria automática baseada em dados' }
  ];

  return (
    <>
      <Header />
      <main className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-orange-600 to-red-600 text-white py-20 pt-32">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-5xl font-bold mb-6">Unisales-IA</h1>
              <p className="text-xl mb-8 text-orange-100">
                Potencialize o seu negócio com inteligência artificial avançada.
                Tome decisões inteligentes, automatize processos e antecipe tendências.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button className="bg-white text-orange-700 px-8 py-3 rounded-full font-semibold hover:bg-orange-50 transition duration-300">
                  Agendar Demonstração
                </button>
                <Link to="/contact" className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-orange-700 transition duration-300">
                  Fale Conosco
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Overview Section */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 gap-12 items-center">
                <div>
                  <h2 className="text-3xl font-bold mb-6">Inteligência Artificial para o seu Negócio</h2>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    O Unisales-IA utiliza as mais avançadas tecnologias de inteligência artificial para
                    otimizar os seus processos de negócio. Desde chatbots inteligentes até análise preditiva,
                    a nossa IA trabalha 24/7 para impulsionar os seus resultados.
                  </p>
                  <ul className="space-y-3">
                    {features.map((feature, index) => (
                      <li key={index} className="flex items-center">
                        <CheckCircle className="w-5 h-5 text-orange-500 mr-3 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="bg-white p-8 rounded-2xl shadow-xl">
                  <div className="text-center">
                    <Brain className="w-16 h-16 text-orange-600 mx-auto mb-4" />
                    <h3 className="text-2xl font-bold mb-4">Resultados Inteligentes</h3>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="text-center">
                        <div className="text-3xl font-bold text-orange-600">90%</div>
                        <p className="text-sm text-gray-600">Precisão nas previsões</p>
                      </div>
                      <div className="text-center">
                        <div className="text-3xl font-bold text-orange-600">60%</div>
                        <p className="text-sm text-gray-600">Redução em tempo de resposta</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">Benefícios Principais</h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                Descubra o poder da IA aplicada ao seu negócio
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {benefits.map((benefit, index) => {
                const IconComponent = benefit.icon;
                return (
                  <div key={index} className="text-center p-6 rounded-xl hover:shadow-lg transition duration-300">
                    <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <IconComponent className="w-8 h-8 text-orange-600" />
                    </div>
                    <h3 className="text-xl font-semibold mb-3">{benefit.title}</h3>
                    <p className="text-gray-600">{benefit.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        {/* <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">O que os nossos clientes dizem</h2>
            </div>
            <div className="max-w-4xl mx-auto">
              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                <blockquote className="text-lg text-gray-700 mb-4">
                  "A Unisales-IA transformou completamente a nossa abordagem de vendas. As previsões são incrivelmente
                  precisas e os nossos chatbots atendem 70% das consultas automaticamente."
                </blockquote>
                <cite className="text-gray-600 font-semibold">
                  Ana Costa, Diretora de Marketing - TechSolutions
                </cite>
              </div>
            </div>
          </div>
        </section> */}

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-orange-600 to-red-600 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Pronto para a revolução da IA?</h2>
            <p className="text-xl mb-8 text-orange-100">
              Descubra como a inteligência artificial pode transformar o seu negócio.
            </p>
            <button className="bg-white text-orange-700 px-8 py-3 rounded-full font-semibold hover:bg-orange-50 transition duration-300">
              Agendar Demonstração Gratuita
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default IAPage;
